export const scrollToAnchor = (e) => {
    e.preventDefault()
    document.getElementById(e.currentTarget.dataset.id).scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
}